const getSelection = (element) => ({
    start: element.selectionStart,
    end: element.selectionEnd,
    direction: element.selectionDirection || 'none',
});
const setSelection = (element, start, end, direction) => {
    element.setSelectionRange(start, end, direction);
};
/**
 * Утилита для работы с выделением текста.
 */
const Selection = {
    /**
     * Возвращает информацию о выделенном тексте в переданом элементе.
     * @param {Element} element textarea или input
     * @returns {Object} Объект со свойствами start, end, direction
     */
    get(element) {
        return getSelection(element);
    },
    /**
     * Возвращает положение каретки в элементе.
     * @throws {TextSelectionError} Выкинет ошибку, если браузер не поддерживают необходимую функциональность.
     * @param {Element} element textarea или input
     * @returns {Number} Позиция каретки
     */
    getCaretPosition(element) {
        const selection = this.get(element);
        if (selection.direction === 'forward') {
            return selection.end;
        }
        return selection.start;
    },
    /**
     * Устанавливает селект на элементе.
     * @param {Element} element     textarea или input
     * @param {Number}  start       Позиция начала текста для выделения
     * @param {Number}  [end]       Позиция конца текста для выделения
     * @param {String}  [direction] Направление выделения текста
     */
    set(element, start, end, direction) {
        element.focus();
        setSelection(element, start, end || start, !direction || !['forward', 'backward'].includes(direction) ? 'none' : direction);
    },
    /**
     * Устанавливает позицию каретки на элементе.
     * @param {Element} element  textarea или input элемент
     * @param {Number}  position Позиция каретки
     */
    setCaretPosition(element, position) {
        this.set(element, position, position);
    },
};

export { Selection };
//# sourceMappingURL=index.js.map
